const translations = {
  fr: {
    radioConfiguration: {
      radioConfigurationPageTitle: 'Configuration de la radio',
      form: 'Formulaire',
      streamConfiguration: 'Configuration du stream',
      playerConfiguration: 'Configuration du player',
      verification: 'Vérification',

      fetchConfigurationFormDataError: "Erreur : impossible de récupérer l'information de configuration.",
      generalInformations: 'Informations générales',
      stationName: 'Nom de la station',
      frequency: 'Fréquence',
      radioType: 'Type de radio',
      commercial: 'Commerciale',
      musical: 'Musicale',
      talk: 'Parlée',
      community: 'Communautaire',
      ethnic: 'Ethnique',
      address: 'Adresse',
      city: 'Ville',
      zipCode: 'Code postal',
      website: 'Site web',

      technologyDirector: 'Responsable des technologies',
      phone: 'Téléphone',

      webAgency: 'Agence web externe',
      webAgencyName: 'Nom de l\'agence',
      webAgencyDirector: 'Nom du responsable de l\'agence',

      streamingTechnologies: 'Technologies actuelles de streaming',
      none: 'Aucune',
      other: 'Autres',
      ifOtherSpecify: 'Spécifiez',

      streamTypes: 'Type de stream',

      currentStreamURL: 'URL du stream',
      currentStreamAndEquipment: 'Stream actuel et équipements',
      averageSimultaneousUsers: 'Moyenne d\'usagers simultanés',

      doYouHaveAWebPlayer: 'Avez-vous un player sur votre site web ?',
      doesYourPlayerShowPlayingSong: 'Le player de votre site web affiche-t-il les chansons ?',

      next: 'Suivant',
      intro: 'Introduction',
      begin: 'Commencer',

      installationAndConfiguration: 'Installation et configuration',
      selectStreamConfiguration: 'Choisissez votre configuration d\'installation du stream',
      statsRadioPlayer: 'Player StatsRadio',
      script: 'Script',

      theme: 'Thème',
      logo: 'Logo',
      backgroundColor: 'Couleur de fond principale',
      mainTextColor: 'Couleur de texte principale',
      secondaryTextColor: 'Couleur de texte secondaire',
      iconBackgroundColor: 'Couleur de fond de l\'icône',
      iconTextColor: 'Couleur de texte de l\'icône',

      banner: 'Bannière',
      doYouWantABannerWithImage: 'Voulez-vous une image de bannière ?',
      bannerImage: 'Image de la bannière',

      stationInformations: 'Informations de la station',
      doYouWantAnInformationSection: 'Voulez-vous une section d\'informations ?',
      informationSectionTitle: 'Titre du bloc d\'information',
      description: 'Description',
      stationLinks: 'Liens de la station',
      addLink: 'Ajouter un lien',
      delete: 'Supprimer',
      title: 'Titre',
      linkHeaderBackgroundColor: 'Couleur de fond du titre',
      linkHeaderTextColor: 'Couleur de texte du titre',
      linkBackgroundColor: 'Couleur de fond des liens',
      linkTextColor: 'Couleur de texte des liens',

      contactUsForThisSection: 'Veuillez nous contacter pour activer cette fonctionnalité',
      songsRecentlyPlayed: 'Chansons récemment jouées',
      doYouWantToDisplayCurrentPlayingSong: 'Voulez-vous afficher la chanson en cours ?',
      doYouWantToDisplaySongHistory: 'Voulez-vous afficher l\'historique des chansons jouées ?',
      maximumOfDisplayedSongInHistory: 'Maximum de chansons à afficher dans l\'historique',
      lastSongsPlayedOn: 'Dernières chansons jouées sur ',
      recentlyPlayed: 'Jouées récemment',
      songTitleExemple: 'Titre de la chanson',
      songDateExemple: 'Date et heure',
      songArtistExemple: 'Nom de l\'artiste',

      playerImageUploadError: 'Il y a eu un problème lors du téléversement de l\'image {{imageType}}.',
      fileUploadMaxSize: '{{limit}}Mo max.',
      saveStepSuccess: 'Vos informations pour cette étape ont été sauvegardées',
      saveStepError: 'Il y a eu une erreur lors de la sauvegarde de l\'étape',
    },
  },
  en: {
    radioConfiguration: {
      radioConfigurationPageTitle: 'Radio configuration',
      form: 'Form',
      streamConfiguration: 'Stream configuration',
      playerConfiguration: 'Player configuration',
      verification: 'Verification',
      fetchConfigurationFormDataError: 'Error : could not fetch configuration information.',
      generalInformations: 'General informations',
      stationName: 'Station name',
      frequency: 'Frequency',
      radioType: 'Radio type',
      commercial: 'Commercial',
      musical: 'Musical',
      talk: 'Talk',
      community: 'Community',
      ethnic: 'Ethnic',
      address: 'Address',
      city: 'City',
      zipCode: 'Zip code',
      website: 'Website',

      technologyDirector: 'Technology manager',
      phone: 'Phone',

      webAgency: 'External web agency',
      webAgencyName: 'Agency name',
      webAgencyDirector: 'Agency manager name',

      streamingTechnologies: 'Streaming technology',
      ifOtherSpecify: 'Please specify',
      none: 'None',
      other: 'Others',

      streamTypes: 'Stream type',

      currentStreamURL: 'Stream URL',
      currentStreamAndEquipment: 'Current stream and equipment',
      averageSimultaneousUsers: 'Average simultaneous users',

      doYouHaveAWebPlayer: 'Do you have a web player ?',
      doesYourPlayerShowPlayingSong: 'Does your player displays the current song\'s title?',

      next: 'Next',
      intro: 'Introduction',
      begin: 'Start',

      installationAndConfiguration: 'Installation and configuration',
      selectStreamConfiguration: 'Select your stream installation configuration',
      statsRadioPlayer: 'StatsRadio player',
      script: 'Script',

      theme: 'Theme',
      logo: 'Logo',
      backgroundColor: 'Main background color',
      mainTextColor: 'Main text color',
      secondaryTextColor: 'Secondary text color',
      iconBackgroundColor: 'Icon background color',
      iconTextColor: 'Icon text color',

      banner: 'Banner',
      doYouWantABannerWithImage: 'Do you want a banner image ?',
      bannerImage: 'Banner image',

      contactUsForThisSection: 'Contact us to activate this feature',
      stationInformations: 'Station information',
      doYouWantAnInformationSection: 'Do you want an information section ?',
      informationSectionTitle: 'Information name',
      description: 'Description',
      stationLinks: 'Station links',
      addLink: 'Add a link',
      delete: 'Delete',
      title: 'Title',
      titleColor: 'Title color',
      linkHeaderBackgroundColor: 'Link header background color',
      linkHeaderTextColor: 'Link header text color',
      linkBackgroundColor: 'Links background color',
      linkTextColor: 'Links text color',

      songsRecentlyPlayed: 'Recently played songs',
      doYouWantToDisplayCurrentPlayingSong: 'Do you want to display the currently playing song ?',
      doYouWantToDisplaySongHistory: 'Do you want to display the song history ?',
      maximumOfDisplayedSongInHistory: 'Maximum songs displayed in history',
      recentlyPlayed: 'Recently played',
      lastSongsPlayedOn: 'Last songs played on ',
      songTitleExemple: 'Song title',
      songDateExemple: 'Date and hour',
      songArtistExemple: 'Artist name',

      playerImageUploadError: 'A problem occured while uploading {{imageType}} image.',
      fileUploadMaxSize: '{{limit}}MB max.',
      saveStepSuccess: 'Your step informations have been saved',
      saveStepError: 'There was an error when saving this step',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/i18n/radioConfiguration.js